export function useFullName({ firstName, lastName } = {}) {
    return `${firstName ? `${firstName} ` : ''}${lastName || ''}`;
};